import { ProductAttributeInterface } from '../../../../Interface/ProductAttribute';
import QuantityInput from '../QuantityInput/QuantityInput';
import NotifyUser from '../../NotifyUser/NotifyUser';

export default function QuantityOrNotify({
  product_attribute,
  price,
  combined_price,
  className,
  allowBackorder = false,
  notifyCompact = false,
}: {
  product_attribute: ProductAttributeInterface;
  price: number;
  combined_price?: number;
  className?: string;
  allowBackorder?: boolean;
  /** Passed to NotifyUser as compact: bell and short label instead of the text. */
  notifyCompact?: boolean;
}) {
  const showQuantityInput = allowBackorder || product_attribute.has_stock;

  if (showQuantityInput) {
    return (
      <QuantityInput
        className={className}
        product_attribute={product_attribute}
        price={price}
        combined_price={combined_price}
        skipStockCheck={allowBackorder}
      />
    );
  }

  return (
    <NotifyUser
      key={`id: ${product_attribute.erp_id} ${Number(
        product_attribute.has_notify_me
      )}`}
      className={className}
      id={product_attribute.erp_id}
      has_notify_me={product_attribute.has_notify_me || false}
      compact={notifyCompact}
    />
  );
}
